export enum ReportTimeGroupByEnum {
  TASK = "task",
  USER = "user",
  CLIENT_GROUP = "client-group",
  INTERVENTION = "intervention",
  MODEL = "model",
  OPERATIVE_UNIT = "operative-unit",
  ZONE = "zone",
  PROJECT = "project",
}
